/** Snapshot of guest/budget/date used for the current plan estimate. */

export const getPlanEstimateCore = (eventData = {}) => ({
  guest_count: Number(eventData?.guest_count || 0),
  budget: Number(eventData?.budget || 0),
  date: eventData?.date || eventData?.event_date || ''
});

export const planEstimateCoresMatch = (a, b) => (
  Number(a?.guest_count) === Number(b?.guest_count)
  && Number(a?.budget) === Number(b?.budget)
  && String(a?.date || '') === String(b?.date || '')
);

export const withPlanEstimateCoreSnapshot = (eventData = {}) => ({
  ...eventData,
  __planEstimateCore: getPlanEstimateCore(eventData)
});

export const ensurePlanEstimateCore = (eventData = {}) => {
  if (eventData?.__planEstimateCore) return eventData;
  return withPlanEstimateCoreSnapshot(eventData);
};

export const needsPlanReEstimate = (eventData = {}) => {
  const baseline = eventData?.__planEstimateCore;
  if (!baseline) return false;
  return !planEstimateCoresMatch(getPlanEstimateCore(eventData), baseline);
};
